<template>
  <div>
    <div class="row">
      <div class="col-lg-8">
        <edit-main
          :is-video="isAVideoTypeUnit"
          :quiz="quiz"
          :unit="unit"
          @removeQuestionIds="getRemoveQuestionIds"
          @removeAnswerIds="getRemoveAnswerIds"
        />
      </div>
      <div class="col-lg-4">
        <assignment
          v-if="!isFetching"
          @users="getAssigned"
          @playlist="getPlaylist"
        />
        <assign-library
          :unit="unit"
          v-if="!isFetching"
          @module="getModule"
          @series="getSeries"
        />
      </div>
    </div>
    <v-snackbar v-if="unit" :timeout="0" v-model="showSnackBar">
      <v-btn
        class="ma-auto"
        color="error"
        small
        :disabled="isLoading"
        :loading="isLoading"
        @click="toggleConfirmDialog"
        >Cancel
      </v-btn>
      <v-btn
        class="ma-auto primaryMainText--text"
        color="primaryMain"
        small
        :disabled="isLoading"
        :loading="isLoading"
        @click="saveUnit(true)"
        >Save and Preview
      </v-btn>
      <v-btn
        class="ma-auto"
        color="success"
        small
        :disabled="isLoading"
        :loading="isLoading"
        @click="saveUnit(false)"
        >Save Changes
      </v-btn>
    </v-snackbar>

    <confirm-dialog
      :close-dialog="closeDialogs"
      :confirm-action="redirectToLivePage"
      :show-dialog="showConfirmDialog"
      :loading="isLoading"
    >
      There are unsaved changes do you want to proceed?
    </confirm-dialog>
    <loading-dialog :loading-dialog="isLoading" :message="loadingMessage" />
  </div>
</template>
<script>
import {
  filter as _filter,
  findIndex as _findIndex,
  find as _find,
  forOwn as _forOwn,
  isEmpty as _isEmpty,
  forEach as _forEach,
  some as _some,
} from 'lodash-es';

import EventBus from '@/plugins/eventBus';
import EditMain from './EditMain';
import Assignment from '@/components/client-lms/UnitPage/partials/Assignment';
import AssignLibraryTreeView from '@/components/client-lms/UnitPage/partials/AssignLibraryTreeView';
import AssignLibrary from '@/components/client-lms/UnitPage/partials/AssignLibrary';
import ConfirmDialog from '@/components/dialogs/ConfirmDialog';
import LoadingDialog from '@/components/course-certification/includes/LoadingDialog';

export default {
  name: 'EditUnit',

  components: {
    EditMain,
    Assignment,
    AssignLibraryTreeView,
    AssignLibrary,
    ConfirmDialog,
    LoadingDialog,
  },

  data: () => ({
    loadingMessage: 'Updating Unit...',
    showSnackBar: true,
    showDialog: false,
    unit: null,
    module_progress: 0,
    series: {
      seriesProgress: 0,
      noCompletedSeries: 0,
      units_left: 0,
    },
    showConfirmDialog: false,
    isFetching: false,
    isReady: false,
    unitProgress: [
      {
        type: 'videoWatched',
        title: 'Watched the Video',
        description: 'you will be scored once you played the video',
        checked: false,
        hide: false,
      },
      {
        type: 'videoCompleted',
        title: 'Finished the Video',
        description:
          'you will be scored once you finished watching the whole video',
        checked: false,
        hide: false,
      },
      {
        type: 'quizCompleted',
        title: 'Answered the Quiz',
        description: 'you will be scored once you answered the provided quiz',
        checked: false,
        hide: false,
      },
      {
        type: 'completedUnit',
        title: 'Completed the Unit',
        description: 'you will be scored once you mark the unit as completed',
        checked: false,
        hide: true,
      },
    ],
    isAVideoTypeUnit: true,
    isUncategozied: false,
    player: null,
    timer: 5,
    timerInterval: null,
    setTimeOut: null,
    proceedingToNext: false,
    isLoading: false,
    assign_users: [],
    display_assigned_users: [],
    assign_groups: [],
    due_date: null,
    module_id: null,
    series_id: null,
    assign_playlist: [],
    display_assigned_playlists: [],
    quiz: {
      create: true,
      id: null,
      title: null,
      passing_rate: 70,
      questions: [],
    },
    toRemoveQuestions: [],
    toRemoveAnswers: [],
  }),

  computed: {
    module() {
      if (this.unit !== null) {
        return this.unit.module;
      }
      return null;
    },
    unitProgressRender() {
      const filtered = _filter(this.unitProgress, { hide: false });

      return _forOwn(filtered);
    },
    played: {
      get() {
        const watchedIndex = 0;
        return this.unitProgress[watchedIndex].checked;
      },
      set() {
        this.checkUnitProgress('videoWatched');
      },
    },
    unitId() {
      return this.$route.params.id;
    },
  },

  created() {
    this.fetchUnit();
  },
  methods: {
    getRemoveQuestionIds(item) {
      this.toRemoveQuestions = item;
    },
    getRemoveAnswerIds(item) {
      this.toRemoveAnswers = item;
    },
    getModule(item) {
      this.module_id = item;
    },
    getSeries(item) {
      this.series_id = item;
    },
    getAssigned(item) {
      this.assign_users = item.assigned_users;
      this.assign_groups = item.assigned_groups;
      this.due_date = item.due_date;
    },
    getPlaylist(item) {
      this.assign_playlist = item;
    },
    toggleConfirmDialog() {
      this.showConfirmDialog = true;
    },
    closeDialogs() {
      this.showConfirmDialog = false;
    },
    nextUnit() {
      EventBus.$emit('nextUnit', true);
    },
    cancel() {
      clearInterval(this.timerInterval);
      clearTimeout(this.setTimeOut);
      this.showDialog = false;
      this.proceedingToNext = false;
    },
    startTimer() {
      this.proceedingToNext = true;
      this.timer = 5;
      this.setTimeOut = setTimeout(() => {
        this.next();
      }, this.timer * 1000);
      this.timerInterval = setInterval(() => {
        if (this.timer > 0) {
          --this.timer;
        } else {
          clearInterval(this.timerInterval);
        }
      }, 1000);
    },
    scrollTo(refName) {
      document.getElementById(refName).scrollIntoView({
        behavior: 'smooth',
      });
    },
    fetchUnit() {
      this.isFetching = true;
      this.$parent.unitPageLoading = true;
      this.axios
        .get('/client/lms/unit/' + this.unitId, {
          params: {
            type: 'module',
          },
        })
        .then(({ data }) => {
          this.isUncategozied = data.is_uncategorized;
          this.series.seriesProgress = data.series_progress;
          this.series.noCompletedSeries = data.no_completed_series;
          this.module_progress = data.module_progress;
          this.series.units_left = data.units_left;
          this.unit = data.unit;
          if (!data.unit.description) {
            this.unit.description = '';
          }
          this.isFetching = false;
          // if the Unit is not a video type
          // then just show the "Completed the Unit" task
          if (
            !(
              data.unit.content.includes('vimeo') ||
              data.unit.content.includes('youtube')
            )
          ) {
            this.isAVideoTypeUnit = false;
            this.hideVideoUnitProgressTasks();
          }
        })
        .catch(() => {
          this.$router.push({
            name: 'PageNotFound',
          });
        })
        .finally(() => {
          console.log('success');
          if (this.unit.is_uploading) {
            if (this.checkTranscodeStatus(this.unit.id)) {
              this.fetchUnit();
            }
          }
        });
    },

    hideUnitProgress(type) {
      const index = _findIndex(this.unitProgress, { type });

      this.unitProgress[index].hide = true;
    },

    hideVideoUnitProgressTasks() {
      const tasks = _forOwn(this.unitProgress);
      const quizCompletedTask = _find(this.unitProgress, {
        type: 'quizCompleted',
      });

      tasks.forEach((item, index) => {
        let value = item.type !== 'completedUnit';

        // if quiz exist in this unit, skip hide of quiz
        if (item.type === 'quizCompleted' && !item.hide) {
          value = false;
        }

        // if item is a "completedUnit" and
        // quiz exist in this unit, hide this item
        if (item.type === 'completedUnit' && !quizCompletedTask.hide) {
          value = true;
        }

        this.unitProgress[index].hide = value;
      });
    },
    setForm() {
      const saveTags = [];
      _forEach(this.unit.tags, (tag) => {
        typeof tag === 'object' ? saveTags.push(tag.id) : saveTags.push(tag);
      });

      let quiz = this.quiz.questions.length > 0 ? this.quiz : null;
      if (this.unit.quiz) {
        quiz = this.unit.quiz;
      }
      const form = new FormData();
      const data = JSON.stringify({
        id: this.unit.id,
        name: this.unit.name,
        is_draft: this.unit.is_draft,
        description: this.unit.description,
        tags: saveTags,
        quiz: quiz,
        series_id: this.series_id,
        module_id: this.module_id,
        questions_to_delete: this.toRemoveQuestions,
        answers_to_delete: this.toRemoveAnswers,
        is_video: this.isAVideoTypeUnit,
        content: this.unit.content,
      });
      form.append('data', data);
      form.append('file', this.unit.content_file);
      form.append('_method', 'PATCH');
      return form;
    },

    saveUnit(preview = false) {
      this.isLoading = true;
      this.axios
        .post('client/lms/update/unit', this.setForm())
        .then(({ data }) => {
          this.unit = data;
          if (!data.description) {
            this.unit.description = '';
          }
          if (this.assign_playlist.length > 0) {
            this.attachToPlaylists(preview);
          } else {
            if (
              (this.assign_users.length > 0 || this.assign_groups > 0) &&
              this.due_date
            ) {
              this.assignUnit(preview);
            } else {
              this.finishUpdate(preview);
            }
          }
        });
    },

    attachToPlaylists(preview = false) {
      this.loadingMessage = 'Attaching to playlists...';
      this.axios
        .post('client/lms/attach/playlist', {
          unit_id: this.unit.id,
          assign_playlists: this.assign_playlist,
        })
        .then(({ data }) => {
          console.log('success attach to playlists');
          if (
            (this.assign_users.length > 0 || this.assign_groups > 0) &&
            this.due_date
          ) {
            this.assignUnit(preview);
          } else {
            this.finishUpdate(preview);
          }
        })
        .catch(() => {
          console.log('something went wrong with attaching to playlists');
        });
    },

    assignUnit(preview = false) {
      this.loadingMessage = 'Assigning to users...';
      const assign = {
        unit_id: this.unit.id,
        user_ids: this.assign_users,
        group_ids: this.assign_groups,
        due_date: this.due_date,
      };
      this.$store
        .dispatch('lmsClient/assignUnit', assign)
        .then(({ data }) => {
          console.log('success assign');
        })
        .catch(() => {
          console.log('something went wrong with assigning to users');
        })
        .finally(() => {
          this.finishUpdate(preview);
        });
    },

    finishUpdate(preview = false) {
      this.isLoading = false;
      this.loadingMessage = 'Updating Unit...';
      this.$notify('success', `${this.unit.name} updated!`);
      EventBus.$emit('removeContentFile');
      if (preview) {
        this.redirectToPreviewPage();
      }
    },

    redirectToPreviewPage() {
      this.$router.push({
        name: 'PreviewUnitPage',
        params: {
          id: this.unit.id,
        },
      });
    },

    redirectToLivePage() {
      this.$router.push({
        name: 'UnitPage',
        params: {
          id: this.unit.id,
        },
      });
    },
  },
};
</script>
